<template lang="pug">
v-container
  div.text-lg.font-medium.basic700--text {{ $t('fees_and_tips') }}
  div.text-sm.font-normal.basic600--text {{ $t('fees_and_tips_desc') }}

  v-row.mt-8(no-gutters)
    v-col(cols="12" sm="7")
      div.d-flex
        div.pr-2
          div.text-md.font-medium.basic700--text {{ $t('optional_tips') }}
          div.text-md.font-normal.basic600--text {{ $t('optional_tips_desc') }}
        v-spacer
        div
          y-switch.mt-1.mb-n3.pa-0(v-model="enableTips")
      //- v-divider.basic300.my-4
      //- div.d-flex
        div.pr-2
          div.text-md.font-medium.basic700--text {{ $t('transfer_transaction_fee') }}
          div.text-md.font-normal.basic600--text {{ $t('transfer_transaction_fee_desc') }}
        v-spacer
        div
          y-switch.mt-1.mb-n3.pa-0(v-model="feesRequired")

  div.d-flex.my-5
    v-spacer
    v-btn.round-lg.heading-6.px-8.ml-4(color="info500" dark depressed height="48") {{ $t('save') }}
  
</template>

<script>
export default {
  name: 'SettingsFeesTips',
  data () {
    return {
      enableTips: true,
      feesRequired: false,
      rules: {
        not_empty: [v => v.trim().length || 'This field is required'],
        not_empty_array: [v => !!(v && v.length) || 'This field is required']
      },
    }
  },

}
</script>

<style scoped>

</style>